<script>
    export default {
        name: 'GiftGuideCatalogLink',

        methods: {
            buildUrl(type, { category, gender, size, deliveryReady }) {
                let suffix = '';

                if (category) {
                    suffix += `${category}/`;
                }

                if (gender) {
                    suffix += `${gender}/`;
                }

                const url = new URL(`${window.location.origin}/${type}/${suffix}`);

                if (size) {
                    url.searchParams.append('tamanho', size);
                }

                if (deliveryReady) {
                    url.searchParams.append('inPhysicalStock', '1');
                }

                return url.toString();
            },
        },
    };
</script>
